import { SPM_POSITION_OFFSET, type SpmPageCodes } from './types';

/** PC 分页的商品/收藏/试戴坑位按结果集连续编号，调用方仍使用页内 position key。 */
export function withProductListPageOffset(codes: SpmPageCodes, offset: number): SpmPageCodes {
  if (offset <= 0 || !codes.product_results) return codes;

  const productResults = {
    ...codes.product_results,
    [SPM_POSITION_OFFSET]: (codes.product_results[SPM_POSITION_OFFSET] ?? 0) + offset,
  };
  return { ...codes, product_results: productResults };
}
